module.exports = __webpack_public_path__ + "static/media/fly0153.76cce46b.webp";